import { AbstractEntity } from "../AbstractEntity";
import Signature from "../Signature";
import { getUtcNow } from "../../utils";
export default class Voyage extends AbstractEntity {
    static prepareEdit(voyage, author) {
        const { voyageNumber, portFrom, portTo, startTime, endTime, estimatedTimeOfArrival } = voyage;
        const newVersion = new Voyage({ author });
        newVersion.voyageNumber = voyageNumber;
        newVersion.portFrom = portFrom;
        newVersion.portTo = portTo;
        newVersion.startTime = startTime;
        newVersion.endTime = endTime;
        newVersion.estimatedTimeOfArrival = estimatedTimeOfArrival;
        newVersion.predecessor = Voyage.createRef(voyage._id);
        return newVersion;
    }
    createdTimestamp = getUtcNow();
    author;
    voyageNumber = '';
    portFrom = '';
    portTo = '';
    startTime = getUtcNow();
    endTime;
    estimatedTimeOfArrival;
    predecessor;
    signature;
    constructor(voyage = {}) {
        super();
        Object.assign(this, voyage);
    }
}
//# sourceMappingURL=Voyage.js.map